// src/components/ui/QuantityStepper/styles.ts
import styled from "styled-components";

export const Wrapper = styled.div<{ $sm?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${(p) => (p.$sm ? 8 : 11)}px;
`;

export const StepButton = styled.button<{ $sm?: boolean }>`
  width: ${(p) => (p.$sm ? 28 : 34)}px;
  height: ${(p) => (p.$sm ? 28 : 34)}px;
  border-radius: ${(p) => (p.$sm ? 28 : 34) / 2.6}px;
  border: none;
  background: ${(p) => p.theme.tokens.colors.softTeal};
  color: ${(p) => p.theme.tokens.colors.teal};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.12s;

  &:disabled {
    background: ${(p) => p.theme.tokens.colors.line};
    color: ${(p) => p.theme.tokens.colors.disabledText};
    cursor: default;
  }
`;

export const Value = styled.span<{ $sm?: boolean }>`
  min-width: 16px;
  text-align: center;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 800;
  font-size: ${(p) => (p.$sm ? 14.5 : 16)}px;
  color: ${(p) => p.theme.tokens.colors.ink};
  font-variant-numeric: tabular-nums;
`;
